// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___3OH7r","collapseIcon":"collapseIcon___1HAec"};